import { ModalBlock } from '@sb1/ffe-modals-react';
import { BodyText, Heading2, MicroText } from '@sb1/ffe-core-react';
import SharePostPreview from '../SharePostPreview';
import { trackEvent } from '../../../support-and-tracking/analytics-actions';
import { Icon } from '@sb1/ffe-icons-react';
import { useProject } from '../../project-hooks/useProject';
import styles from './shareOnProjectMobile.module.less';
import { IMAGE, INSTAGRAM, QR, TVA_IMAGES } from './share-on-project-model';
import NativeShareButton from '../NativeShareButton';
import Image from '../../../components/image/Image';
import image from '@sb1/ffe-icons/icons/open/300/lg/image.svg';
import qr from '@sb1/ffe-icons/icons/open/300/lg/qr_code.svg';
import FacebookShareButton from '../FacebookShareButton';
import { SecondaryButton } from '@sb1/ffe-buttons-react';
import { InputWithCopyButton } from '../../../components/input-with-copy/InputWithCopyButton';
import { useSelector } from 'react-redux';
import { isProjectPartOfTVA } from '../../project-model';

export const MobileStartModalContainer = ({ setShowPage, prettyUrlToShare, trackingProperties, subprojectId }) => {
    const project = useProject();
    const campaigns = useSelector((state) => state.campaigns);
    const isTvaProject = isProjectPartOfTVA(campaigns, project);

    const trackClick = (channel) => {
        trackEvent('project', 'share-mobile-modal', {
            channel,
            ...trackingProperties,
        });
    };

    return (
        <ModalBlock>
            <Heading2 id="share-modal-title">Del spleisen</Heading2>
            <BodyText className={styles.mobileIngress}>
                Deler du spleisen med nettverket ditt bidrar du i snitt med 1000 kr ekstra til spleisen 💰
            </BodyText>
            <SharePostPreview projectId={project.id} subprojectId={subprojectId} className={styles.projectPreview} />
            <div className={styles.mobileSharingButtons}>
                <FacebookShareButton
                    urlToShare={prettyUrlToShare}
                    titleToShare={project.title}
                    logoAsButton={true}
                    trackEventFunction={() => trackClick('facebook')}
                    isNative
                />
                <div className={styles.buttonGroup}>
                    <SecondaryButton
                        className={[styles.roundButton, styles.instagramLogoButton].join(' ')}
                        onClick={() => {
                            setShowPage(INSTAGRAM);
                            trackClick('show-instagram-modal');
                        }}
                        aria-label={'Del på Instagram'}
                        iconOnly
                    >
                        <Image src="instagram_story.svg" height={48} width={48} />
                    </SecondaryButton>
                    <MicroText className={styles.shareDescription} aria-hidden>
                        Instagram-historie
                    </MicroText>
                </div>
                {!isTvaProject && (
                    <div className={styles.buttonGroup}>
                        <SecondaryButton
                            onClick={() => {
                                setShowPage(IMAGE);
                                trackClick('show-image-modal');
                            }}
                            className={styles.roundButton}
                            aria-label={'Del bilde'}
                            iconOnly
                        >
                            <Icon fileUrl={image} size="lg" />
                        </SecondaryButton>
                        <MicroText className={styles.shareDescription} aria-hidden>
                            Bilde
                        </MicroText>
                    </div>
                )}

                {isTvaProject && project.img_url && (
                    <div className={styles.buttonGroup}>
                        <SecondaryButton
                            iconOnly
                            label="Bilde"
                            onClick={() => {
                                setShowPage(TVA_IMAGES);
                                trackClick('show-tva-image-modal');
                            }}
                            className={styles.roundButton}
                        >
                            <Icon fileUrl={image} size="lg" />
                        </SecondaryButton>
                        <MicroText className={styles.shareDescription} aria-hidden>
                            Bilder
                        </MicroText>
                    </div>
                )}

                <div className={styles.buttonGroup}>
                    <SecondaryButton
                        onClick={() => {
                            setShowPage(QR);
                            trackClick('show-qr-modal');
                        }}
                        className={styles.roundButton}
                        aria-label="Del QR-kode"
                        iconOnly
                    >
                        <Icon fileUrl={qr} size="lg" />
                    </SecondaryButton>
                    <MicroText className={styles.shareDescription} aria-hidden>
                        QR-kode
                    </MicroText>
                </div>
            </div>
            <div>
                <InputWithCopyButton
                    label={'Lenke til spleisen'}
                    prettyUrlToShare={prettyUrlToShare}
                    trackEventFunction={() => trackClick('copy')}
                    isNative
                />
            </div>
            <NativeShareButton
                text={'Del spleisen'}
                className={styles.shareButton}
                urlToShare={prettyUrlToShare}
                titleToShare={project.title}
                trackEventFunction={() => trackClick('native')}
            />
        </ModalBlock>
    );
};
